import React, { useContext, useRef, useState, useEffect } from 'react';

import ComoFunciona from './ComoFunciona';

import Paginacao from '../../Paginacao';

import { ContextoListaApartamentos } from '../../ApartamentList/contextoImoveis';

import { ContextRenegociacao } from '../../../services/renegociacao';

import ValorTotal from './DadosUsuario/ValorTotal';

import ValorEntrada from './DadosUsuario/ValorEntrada';

import VencimentoEntrada from './DadosUsuario/VencimentoEntrada';

import VencimentoParcelas from './DadosUsuario/VencimentoParcelas';

import SimularBtn from './DadosUsuario/SimularBtn';

import NumeroParcelas from './DadosUsuario/NumeroParcelas';

import Simulacao from './Simulacao';

import { Spinner } from '../../StyledComponent';

import {
  MsgErroRenegociacao,
  Container,
  ItemsContainer,
  MinhaRenegociacaoHeader,
} from './styles';

import { ReactComponent as Erro } from '../../../assets/icones/error.svg';
import MesVencimentoPrimeiraParcela from './DadosUsuario/MesVencimentoPrimeiraParcela';
const Renegociacao = ({
  contratoSelecionado,
  setshowParcelasPagar,
  setShowRenegociacao,
  getParcelasAPagar,
}) => {
  const { tema } = useContext(ContextoListaApartamentos);

  const { getParcelasRenegociacao } = useContext(ContextRenegociacao);

  const [estilo, setEstilo] = useState({});

  const [showSimulacao, setShowSimulacao] = useState(false);

  const [parcelasRenegociacao, setParcelasRenegociacao] = useState([]);

  const [valorTotalAtualizado, setValorTotalAtualizado] = useState(
    regras?.valorTotal
  );

  const [loadingParcelasRenegociacao, setLoadingParcelasRenegociacao] =
    useState(true);

  const item = useRef();

  const [regras, setRegras] = useState({
    valorTotal: '',
    entrada: '',
    vencimentoEntrada: '',
    numeroParcelas: '',
    vencimentoParcelas: '',
  });

  const [aptoARenegociar, setAptoARenegociar] = useState(true);
  const [isErrorGetParcelasRenegociacao, setisErrorGetParcelasRenegociacao] =
    useState(false);

  const [errorMessage, setErrorMessage] = useState('');

  const msgErroParcelasProcessandoCartao =
    'Não é possível renegociar, pois existem parcelas processando pagamento com cartão. Após a baixa dessas parcelas, tente novamente. ';

  const msgErroParcelaBoleto =
    'Não é possível renegociar, pois você tem um boleto em aberto para pagamento. Entre em contato com a Direcional no número (31) 4002-2600 para fazer o cancelamento do boleto, após o cancelamento tente novamente.';

  const msgErroPagamentoPix =
    'Não é possível renegociar, pois existem parcelas aguardando pagamento com pix. Após a baixa dessas parcelas, tente novamente. ';

  const getParcelas = async () => {
    setisErrorGetParcelasRenegociacao(false);
    setErrorMessage('');

    if (!loadingParcelasRenegociacao) setLoadingParcelasRenegociacao(true);

    let idsVenda = {
      IdVenda:
        contratoSelecionado?.idVenda || contratoSelecionado?.contrato?.idVenda,
      IdVendaCarteira:
        contratoSelecionado?.idVendaCarteira ||
        contratoSelecionado?.contrato?.idVendaCarteira,
    };
    console.log(contratoSelecionado);
    try {
      let temp = await getParcelasRenegociacao(idsVenda);
      if (temp.status === 204) {
        setAptoARenegociar(false);
      }

      setRegras({ ...regras, ...temp?.data?.regras });

      setValorTotalAtualizado(temp?.data?.regras?.valorTotal);

      setParcelasRenegociacao(temp?.data?.parcelas);
    } catch (error) {
      console.error(error);

      setisErrorGetParcelasRenegociacao(true);
      handleErrorMessage(error.response.data);
    } finally {
      setLoadingParcelasRenegociacao(false);
    }
  };

  useEffect(() => {
    getParcelas();
  }, [contratoSelecionado]);

  useEffect(() => {
    if (item.current) {
      setEstilo(item.current.clientWidth);
    }
  }, [item.current]);

  const refSimulacao = useRef(null);
  const executeScroll = () => refSimulacao.current.scrollIntoView();

  function handleShowSimulacao() {
    executeScroll();
    setShowSimulacao((prevState) => !prevState);
  }

  function handleErrorMessage(errorMessage) {
    let message = '';

    if (aptoARenegociar) {
      switch (errorMessage) {
        case msgErroParcelasProcessandoCartao:
          message = msgErroParcelasProcessandoCartao;
          break;

        case msgErroParcelaBoleto:
          message = msgErroParcelaBoleto;
          break;

        case msgErroPagamentoPix:
          message = msgErroPagamentoPix;
          break;

        default:
          if (!regras.valorTotal > 0) {
            message = 'Erro. Tente novamente mais tarde!';
          }
          break;
      }
    } else {
      message = 'No momento esse contrato não está apto à renegociação.';
    }

    setErrorMessage(message);
  }

  if (loadingParcelasRenegociacao) return <Spinner />;
  return (
    <>
      {regras.valorTotal > 0 && (
        <div ref={refSimulacao}>
          {showSimulacao && (
            <Container style={{ padding: 0 }}>
              <MinhaRenegociacaoHeader
                style={{
                  backgroundColor: tema.primaryColor,
                }}
              >
                <p
                  style={{
                    margin: 0,
                    color: '#ffffff',
                    fontWeight: 'bold',
                    fontSize: '16px',
                  }}
                >
                  Minha renegociação
                </p>
              </MinhaRenegociacaoHeader>
              <Container style={{ border: 'none', marginTop: 0 }}>
                <Simulacao
                  handleShowSimulacao={handleShowSimulacao}
                  tema={tema}
                  regras={regras}
                  contratoSelecionado={contratoSelecionado}
                  setLoadingParcelasRenegociacao={
                    setLoadingParcelasRenegociacao
                  }
                  setshowParcelasPagar={setshowParcelasPagar}
                  setShowRenegociacao={setShowRenegociacao}
                  getParcelasAPagar={getParcelasAPagar}
                />
              </Container>
            </Container>
          )}

          <Container
            style={showSimulacao ? { display: 'none' } : { display: 'block' }}
          >
            <ItemsContainer>
              <ValorTotal
                setRegras={setRegras}
                regras={regras}
                valorTotalAtualizado={valorTotalAtualizado}
                setValorTotalAtualizado={setValorTotalAtualizado}
              />

              <ValorEntrada setRegras={setRegras} regras={regras} tema={tema} />

              <VencimentoEntrada
                estilo={estilo}
                setRegras={setRegras}
                regras={regras}
                tema={tema}
              />

              <NumeroParcelas
                item={item}
                estilo={estilo}
                setRegras={setRegras}
                regras={regras}
                tema={tema}
              />

              <VencimentoParcelas
                estilo={estilo}
                setRegras={setRegras}
                regras={regras}
                tema={tema}
              />
              <MesVencimentoPrimeiraParcela
                estilo={estilo}
                setRegras={setRegras}
                regras={regras}
                tema={tema}
              />
            </ItemsContainer>
            <SimularBtn
              tema={tema}
              setRegras={setRegras}
              regras={regras}
              valorTotalAtualizado={valorTotalAtualizado}
              handleShowSimulacao={handleShowSimulacao}
              contratoSelecionado={contratoSelecionado}
            />

            {!loadingParcelasRenegociacao &&
              parcelasRenegociacao?.length > 0 && (
                <Paginacao
                  parcelas={parcelasRenegociacao}
                  tema={tema}
                  tipo='aPagar'
                  simulador
                  desabilitarBtnSelecionarParcela
                  parcelasAPagar={parcelasRenegociacao}
                />
              )}
          </Container>
          <ComoFunciona />
        </div>
      )}

      {isErrorGetParcelasRenegociacao && (
        <MsgErroRenegociacao>
          <Erro />
          <b>{errorMessage}</b>
        </MsgErroRenegociacao>
      )}
    </>
  );
};

export default Renegociacao;
